import service from '@/utils/request'; // @Tags BairunSvcBalanceSub
// @Summary 创建BairunSvcBalanceSub
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body model.BairunSvcBalanceSub true "创建BairunSvcBalanceSub"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /bairunSvcBalanceSub/createBairunSvcBalanceSub [post]

export var createBairunSvcBalanceSub = function createBairunSvcBalanceSub(data) {
  return service({
    url: '/svcManage/svcBalanceSub/create',
    method: 'post',
    data: data
  });
}; // @Tags BairunSvcBalanceSub
// @Summary 删除BairunSvcBalanceSub
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body model.BairunSvcBalanceSub true "删除BairunSvcBalance"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"删除成功"}"
// @Router /BairunSvcBalanceSub/deleteBairunSvcBalance [delete]

export var deleteBairunSvcBalanceSub = function deleteBairunSvcBalanceSub(data) {
  return service({
    url: '/svcManage/svcBalanceSub/delete',
    method: 'post',
    data: data
  });
}; // @Tags BairunSvcBalanceSub
// @Summary 删除BairunSvcBalance
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body request.IdsReq true "批量删除BairunSvcBalance"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"删除成功"}"
// @Router /BairunSvcBalanceSub/deleteBairunSvcBalance [delete]

export var deleteBairunSvcBalanceSubByIds = function deleteBairunSvcBalanceSubByIds(data) {
  return service({
    url: '/svcManage/svcBalanceSub/deleteByIds',
    method: 'post',
    data: data
  });
}; // @Tags BairunSvcBalanceSub
// @Summary 更新BairunSvcBalance
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body model.BairunSvcBalanceSub true "更新BairunSvcBalance"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"更新成功"}"
// @Router /BairunSvcBalanceSub/updateBairunSvcBalance [put]

export var updateBairunSvcBalanceSub = function updateBairunSvcBalanceSub(data) {
  return service({
    url: '/svcManage/svcBalanceSub/update',
    method: 'put',
    data: data
  });
}; // @Tags BairunSvcBalanceSub
// @Summary 用id查询BairunSvcBalance
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body model.BairunSvcBalanceSub true "用id查询BairunSvcBalance"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"查询成功"}"
// @Router /BairunSvcBalanceSub/findBairunSvcBalance [get]

export var findBairunSvcBalanceSub = function findBairunSvcBalanceSub(params) {
  return service({
    url: '/svcManage/svcBalanceSub/find',
    method: 'get',
    params: params
  });
}; // @Tags BairunSvcBalanceSub
// @Summary 分页获取BairunSvcBalance列表
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body request.PageInfo true "分页获取BairunSvcBalance列表"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /BairunSvcBalanceSub/getBairunSvcBalanceSubList [get]

export var getBairunSvcBalanceSubList = function getBairunSvcBalanceSubList(params) {
  return service({
    url: '/svcManage/svcBalanceSub/getList',
    method: 'get',
    donNotShowLoading: params.donNotShowLoading ? params.donNotShowLoading : true,
    params: params
  });
};
export var updateBairunSvcBalanceSubStatus = function updateBairunSvcBalanceSubStatus(data) {
  return service({
    url: '/svcManage/svcBalanceSub/open/close',
    method: 'post',
    data: data
  });
};